import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useToggles } from '@mo/hooks';
import './app-layout.scss';
//import LoggedOutHeader from './header/LoggedOutHeader';
import LoggedOutFooter from './footer/LoggedOutFooter';

interface TogglesLoadedResponse {
    toggles: { [toggleName: string]: boolean };
    togglesRetrieved: boolean;
}

export interface MinimalAppLayoutProps {
    baseUrl: string;
    currentPath: string;
    children?: ReactNode;
    onTogglesLoaded?: (togglesLoadedResponse: TogglesLoadedResponse) => void;
}

const BasicAppLayout: React.FunctionComponent<MinimalAppLayoutProps> = ({
    baseUrl,
    children,
    onTogglesLoaded,
}: MinimalAppLayoutProps): ReactElement | null => {
    const { toggles, togglesRetrieved } = useToggles(`${baseUrl}/conf/toggles`);

    useEffect(() => {
        onTogglesLoaded && onTogglesLoaded({ toggles, togglesRetrieved });
    }, [toggles, togglesRetrieved]);

    if (!togglesRetrieved) {
        return null;
    }

    return (
        <div className='app-layout__basic'>
            {/* <LoggedOutHeader className='app-layout__header' role={'banner'} /> */}

            <main className='app-layout__content'>{children}</main>

            <LoggedOutFooter className='app-layout__footer' />
        </div>
    );
};

export default BasicAppLayout;
